import { useTypedParams } from '@sorare/routing';
import { parsePlayerPoolTierSlug } from '@sorare/core/src/lib/playerPoolTiers';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import { RewardsFixtureLeagueTierRarityPage } from '#src/pages/rewards/RewardsFixtureLeagueTierRarityPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const RewardsPage = () => {
  const { league, tier, rarity } = useTypedParams<PageParams>();
  const poolTier = parsePlayerPoolTierSlug(tier);

  if (!poolTier || !isRarityStr(rarity)) {
    return null;
  }

  return (
    <RewardsFixtureLeagueTierRarityPage
      league={league}
      tier={poolTier}
      rarity={rarity}
    />
  );
};

export default RewardsPage;
